import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { getShareStatus, cdDir, getDownloadUuid, getDownloadUrl, analyticFolder, getDeviceInfo, getBaseUrlReady, getBaseURL, setBaseURL, getSingleFilePreviewUrl, getSingleFileThumbnailUrl, getSingleFileDownloadUrl } from "./api/index";
import querystring from "query-string";
import { Toast } from "vant";
import "vant/es/toast/style";
import { filesize } from "filesize";
import JSZip from "jszip";
import dayjs from "dayjs";
import { baseURL, setEnv, setLocale as setAxiosLocale } from "./api/axios";
import { setLocale as setI18nLocale, getCurrentLocale } from "./i18n";
function parseUFI(ufiPath) {
  const ufiPattern = /^\/ufi\/([^/]+)\/([^/]+)(\/.*)?$/;
  const match = ufiPath.match(ufiPattern);
  if (!match) {
    return null; // 路径格式不正确，返回null
  }

  // eslint-disable-next-line no-unused-vars
  const [_, storageType, storageUuid, fullPath = ""] = match;
  return {
    ufiPrefix: `/ufi/${storageType}/${storageUuid}`,
    fullPath,
    storageType,
    storageUuid
  };
}
function setFavicon(url) {
  let link = document.querySelector("link[rel='icon']");
  if (!link) {
    // 如果没有找到现有的 <link> 标签，就创建一个新的
    link = document.createElement("link");
    link.rel = "icon";
    document.head.appendChild(link);
  }

  // 设置新的 favicon URL
  link.href = url;
}
export default {
  name: "App",
  data() {
    return {
      baseURL: baseURL,
      loadingNodeInfo: true,
      loadingNodeInfoFailed: false,
      loadingNodeInfoMsgKey: "",
      loading: false,
      outdate: false,
      invalidUrl: false,
      needVerifyCode: true,
      dir: "/",
      cdnMode: true,
      uuid: "",
      shareCode: "",
      verifyCode: "",
      region: "",
      brandName: "",
      brandNameEn: "",
      homepage: "",
      totalSize: 0,
      filelist: [],
      checked: [],
      shareInfo: {},
      currentLocale: getCurrentLocale(),
      supportedLanguages: [{
        code: "en",
        name: "English"
      }, {
        code: "zh-CN",
        name: "简体中文"
      }, {
        code: "zh-TW",
        name: "繁體中文"
      }, {
        code: "zh-HK",
        name: "繁體中文(香港)"
      }, {
        code: "de",
        name: "Deutsch"
      }, {
        code: "es",
        name: "Español"
      }, {
        code: "fr",
        name: "Français"
      }, {
        code: "it",
        name: "Italiano"
      }, {
        code: "ja",
        name: "日本語"
      }, {
        code: "ko",
        name: "한국어"
      }, {
        code: "pt",
        name: "Português"
      }, {
        code: "ru",
        name: "Русский"
      }]
    };
  },
  mounted() {
    this.initPage();
  },
  computed: {
    isBigScreen() {
      return window.innerWidth > 500;
    },
    dirs() {
      var list = [{
        name: `/${this.$t("common.rootDirectory")}`,
        path: "/"
      }];
      if (!this.dir || this.dir === "/") {
        return list;
      }
      const ufiObj = parseUFI(this.dir);
      console.log("ufiObj", ufiObj);
      const dirarr = ufiObj.fullPath.split("/");
      return [...list, ...dirarr.map((item, index) => {
        if (index === 0) {
          return {
            name: `/${ufiObj.storageType}:${ufiObj.storageUuid}`,
            path: `/ufi/${ufiObj.storageType}/${ufiObj.storageUuid}`
          };
        }
        return {
          name: "/" + item,
          path: ufiObj.ufiPrefix + dirarr.slice(0, index + 1).join("/")
        };
      })];
    },
    // 根据当前语言决定显示 brandName 还是 brandNameEn
    displayBrandName() {
      // 如果是中文环境，使用 brandName，否则使用 brandNameEn
      const isChinese = ["zh-CN", "zh-TW", "zh-HK"].includes(this.currentLocale);
      return isChinese ? this.brandName : this.brandNameEn || this.brandName;
    },
    pageTitle() {
      return `${this.displayBrandName}${this.$t("brand.fileShare")}`;
    }
  },
  watch: {
    pageTitle(newTitle) {
      window.document.title = newTitle;
    },
    dirs() {
      this.checked = [];
      console.log("dirs", this.dirs);
    },
    $route() {
      this.dir = this.$route.query.dir || "/";
      getBaseUrlReady.promise.then(() => {
        this.getFileList();
      });
    },
    filelist() {
      this.filelist.forEach(file => {
        this.ctotal();
        if (file.fileInfo.isDir) {
          analyticFolder(this.shareCode, this.verifyCode, file.ufi).then(resp => {
            if (resp.code === "A00200") {
              file.fileInfo.size = resp.data;
              this.ctotal();
            }
          });
        }
      });
    }
  },
  methods: {
    changeLocale() {
      setI18nLocale(this.currentLocale);
      setAxiosLocale(this.currentLocale);
    },
    initPage() {
      var paths = document.location.pathname.split("/") || [];
      // 有pathuuid的是NAS直连的情况，否则是通过CDN访问
      var pathuuid = !document.location.href.startsWith("https://share.") && paths.length >= 2 ? paths[1] : "";
      this.cdnMode = !pathuuid;
      var baseurl = "";
      if (pathuuid) {
        baseurl = `${document.location.protocol}//${document.location.host}/${pathuuid}`;
      }
      const se = querystring.parse(window.location.search);
      this.uuid = se.uuid;
      this.shareCode = se.code;
      // 清理 verifyCode，去除 URL hash 和路径符号
      this.verifyCode = se.verifycode ? se.verifycode.replace(/[#\/].*$/, "") : "";
      // 如果 URL 中没有 verifyCode，尝试从 sessionStorage 读取
      if (!this.verifyCode && this.shareCode) {
        const cached = sessionStorage.getItem(`verifyCode_${this.shareCode}`);
        if (cached) {
          this.verifyCode = cached;
        }
      }
      var region = typeof se.region === "string" ? se.region.toUpperCase() : "OLD";
      this.region = ["OLD", "CN", "SEA", "EU", "US-WEST", "US-EAST"].includes(region) ? region : "OLD";
      if (this.cdnMode && !this.region) {
        this.loadingNodeInfo = false;
        this.loadingNodeInfoFailed = true;
        this.loadingNodeInfoMsgKey = "error.missingRegion";
        return;
      }
      this.loadingNodeInfo = true;
      const isProd = se.env !== "test";
      setEnv(isProd);
      getBaseURL(this.uuid, this.shareCode, this.verifyCode, baseurl, this.region).then(resp => {
        setBaseURL(resp);
        this.baseURL = resp;
        setFavicon(`${resp}/syy/assets/mainboard/favicon`);
        this.loadingNodeInfo = false;
        this.dir = this.$route.query.dir || "/";
        this.getStatus();
        getDeviceInfo().then(resp => {
          if (resp.code === "A00200") {
            this.brandName = resp.data.mainBoard.brandName;
            this.brandNameEn = resp.data.mainBoard.brandNameEn;
            this.homepage = resp.data.mainBoard.homepage;
          }
        });
      }).catch(err => {
        if (err.code === "A00500") {
          this.loadingNodeInfo = false;
          this.loadingNodeInfoFailed = true;
          this.loadingNodeInfoMsgKey = this.region === "OLD" ? "error.outdatedLink" : "error.connectionFailed";
        } else {
          this.loadingNodeInfo = false;
          this.loadingNodeInfoFailed = true;
          this.loadingNodeInfoMsgKey = "error.registryError";
        }
      });
    },
    getSingleFileThumbnailUrl() {
      return getSingleFileThumbnailUrl(...arguments);
    },
    getSafeTextOverflow(str, start = 5, end = 5) {
      if (str.length <= start + end + 3) {
        return str;
      }
      return str.substring(0, start) + "..." + str.substring(str.length - end);
    },
    filesize(size = 0) {
      return filesize(size, {
        base: 2,
        standard: "jedec"
      });
    },
    ctotal() {
      this.totalSize = this.filelist.reduce((total, current, index, list) => {
        total = total + current.fileInfo.size;
        return total;
      }, 0);
    },
    dtformat(ms) {
      return dayjs(ms).format("YYYY-MM-DD HH:mm:ss");
    },
    async getStatus() {
      if (!this.shareCode) {
        return this.invalidUrl = true;
      }
      try {
        this.loading = true;
        var res = await getShareStatus(this.shareCode);
        this.loading = false;
        if (res.code === "CST0104") {
          return this.outdate = true;
        }
        if (res.code === "CST0105") {
          this.outdate = false;
          this.needVerifyCode = true;
          return;
        }
        if (res.code === "A00200") {
          this.shareInfo = res.data;
          this.outdate = false;
          // 如果接口返回需要提取码，或者当前 URL 中没有提取码，则显示输入框
          if (res.data.needVerifyCode || !this.verifyCode) {
            this.needVerifyCode = true;
          } else {
            this.needVerifyCode = false;
            this.getFileList();
          }
          return;
        }
        throw new Error(res.msg);
      } catch (error) {
        this.loading = false;
        this.invalidUrl = true;
      }
    },
    async verify() {
      if (!this.verifyCode) {
        return Toast(this.$t("share.needVerifyCode"));
      } else {
        try {
          var res = await cdDir(this.shareCode, this.verifyCode, this.dir);
          this.loading = false;
          if (res.code === "A00200") {
            var _res$data;
            this.filelist = ((_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.data) || [];
            this.needVerifyCode = false;
            // 校验成功，保存到 sessionStorage
            sessionStorage.setItem(`verifyCode_${this.shareCode}`, this.verifyCode);
          } else if (res.code === "CST0106") {
            this.needVerifyCode = true;
            Toast(this.$t("share.extractionCodeError"));
          } else {
            Toast(res.msg || this.$t("share.unknownError"));
          }
        } catch (error) {
          this.loading = false;
          this.needVerifyCode = true;
        }
      }
    },
    clickpush(p) {
      this.$router.push({
        path: "/",
        query: {
          dir: p
        }
      });
    },
    clickItem(item) {
      if (item.isDir) {
        this.$router.push({
          path: "/",
          query: {
            dir: item.ufi
          }
        });
      } else {
        window.open(getSingleFilePreviewUrl(this.shareCode, this.verifyCode, item.ufi));
      }
    },
    async getFileList() {
      if (!this.verifyCode) {
        this.needVerifyCode = true;
        return;
      }
      try {
        this.loading = true;
        var res = await cdDir(this.shareCode, this.verifyCode, this.dir);
        if (res.code === "A00200") {
          var _res$data2;
          this.filelist = res.data instanceof Array ? res.data : ((_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.data) || [];
        } else if (res.code === "CST0106") {
          this.needVerifyCode = true;
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.invalidUrl = true;
      }
    },
    toggleSelected() {
      if (this.checked.length > 0) {
        this.checked = [];
      } else {
        this.checked = this.filelist.map(file => file.ufi);
      }
    },
    async downloadAll() {
      var ufis = this.filelist.map(item => item.ufi);
      try {
        var res = await getDownloadUuid(this.shareCode, this.verifyCode, ufis);
        console.log("getDownloadUuid", res);
        if (!res.data) {
          return Toast(this.$t("share.uuidRequestFailed"));
        }
        var url = getDownloadUrl(this.shareCode, this.verifyCode, res.data);
        this.down(url, "");
      } catch (error) {
        Toast(error.message);
      }
    },
    async download() {
      var isSingleDir = false;
      var singleFileName = "";
      if (this.checked.length === 1) {
        var _fileItem$fileInfo;
        var fileItem = this.filelist.find(file => file.ufi === this.checked[0]);
        isSingleDir = (fileItem === null || fileItem === void 0 ? void 0 : fileItem.fileInfo.isDir) || false;
        singleFileName = (fileItem === null || fileItem === void 0 || (_fileItem$fileInfo = fileItem.fileInfo) === null || _fileItem$fileInfo === void 0 ? void 0 : _fileItem$fileInfo.name) || "";
      }
      if (this.checked.length === 0) {
        return Toast(this.$t("share.selectFilesFirst"));
      } else if (this.checked.length === 1 && !isSingleDir) {
        try {
          const url = await getSingleFileDownloadUrl(this.shareCode, this.verifyCode, this.checked[0]);
          console.log("getSingleFileDownloadUrl", url);
          this.down(url, singleFileName);
        } catch (error) {
          Toast(error.message);
        }
      } else {
        try {
          const res = await getDownloadUuid(this.shareCode, this.verifyCode, this.checked);
          console.log("getDownloadUuid", res);
          if (!res.data) {
            return Toast(this.$t("share.uuidRequestFailed"));
          }
          const url = getDownloadUrl(this.shareCode, this.verifyCode, res.data);
          this.down(url, "");
        } catch (error) {
          Toast(error.message);
        }
      }
    },
    down(url, name) {
      fetch(url, {
        headers: {
          Range: "bytes=0-1"
        }
      }).then(response => {
        const contentType = response.headers.get("Content-Type") || "";
        const isZip = contentType.includes("application/zip");
        // 判断是否为 livp 返回的 zip：Content-Type 为 zip 且原始文件名以 .livp 结尾
        const isLivpZip = isZip && name && name.toLowerCase().endsWith(".livp");
        if (isLivpZip) {
          return response.blob().then(blob => {
            return JSZip.loadAsync(blob).then(zip => {
              const files = Object.keys(zip.files).filter(f => !zip.files[f].dir);
              if (files.length === 1) {
                // 单文件直接下载
                return zip.files[files[0]].async("blob").then(fileBlob => {
                  const fileUrl = URL.createObjectURL(fileBlob);
                  this.triggerDownload(fileUrl, files[0]);
                  URL.revokeObjectURL(fileUrl);
                });
              }
              // 多文件逐个下载
              const chain = files.reduce((p, f) => {
                return p.then(() => zip.files[f].async("blob")).then(fileBlob => {
                  const fileUrl = URL.createObjectURL(fileBlob);
                  this.triggerDownload(fileUrl, f);
                  URL.revokeObjectURL(fileUrl);
                });
              }, Promise.resolve());
              return chain;
            });
          });
        }
        // 非 livp-zip 场景：直接下载
        this.triggerDownload(url, name);
        // response.blob().then((blob) => {
        //   const blobUrl = URL.createObjectURL(blob);
        //   // 从 Content-Disposition 提取文件名，否则用原始 name
        //   let filename = name;
        //   const disposition = response.headers.get("Content-Disposition");
        //   if (disposition) {
        //     const match = disposition.match(
        //       /filename\*?=(?:UTF-8''|"?)([^";]+)/i
        //     );
        //     if (match) {
        //       filename = decodeURIComponent(match[1].replace(/"$/, ""));
        //     }
        //   }
        //   this.triggerDownload(blobUrl, filename);
        //   URL.revokeObjectURL(blobUrl);
        // });
      }).catch(err => {
        console.error("download error", err);
        Toast(err.message);
      });
    },
    triggerDownload(url, name) {
      const aDom = document.createElement("a");
      aDom.style.display = "none";
      aDom.href = url;
      if (name) {
        aDom.download = name;
      }
      document.body.appendChild(aDom);
      aDom.click();
      document.body.removeChild(aDom);
    }
  }
};